module.exports = __webpack_public_path__ + "media/mypage/images/fa/9-9523b9a6e2db519059d8c1f473941f5e.jpg";